import type { Configuration } from '@/config';
import { useContainer } from '.';

export const useConfig = (): Configuration => useContainer().config;
